// @flow
import React, { Fragment, useContext } from 'react';
import { isEmpty } from 'lodash';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { SocialPicture } from 'Components/frameworks/social-picture/SocialPicture.jsx';
import { getSocialPictureGridLayout } from './SocialPicturesGrid.utils';

type Props = {
  pictures: Array<?{
    src: string,
    thumbnailSrc: string,
    userName: string,
  }>,
};

const fillUpScheme = {
  // hardcoding how we're filling the grid depending on how many pictures we have
  // is this the best way to do it? idk but It Works™
  // note: if we had the precise dimensions of the pictures beforehand we actually
  // could build a much more powerful layout engine but maybe that'd be overkill?
  '5': [1, 0, 1, 1, 0, 0, 1, 0, 1],
  '6': [1, 0, 1, 1, 1, 0, 1, 0, 1],
  '7': [1, 0, 1, 1, 1, 1, 1, 0, 1],
  '8': [1, 1, 1, 1, 1, 1, 1, 0, 1],
  '9': [1, 1, 1, 1, 1, 1, 1, 1, 1],
};

export function SocialPicturesGrid(props: Props) {
  const { isTablet } = useContext(ResponsiveContext);
  const { pictures = [] } = props;
  const numberOfPictures = pictures.length;
  const imageStyles = getSocialPictureGridLayout(numberOfPictures);

  if (isEmpty(pictures)) {
    return null;
  }

  const paddedPictures = pictures.slice(0);

  const currentFillUpScheme = fillUpScheme[numberOfPictures];
  for (let i = 0; i < currentFillUpScheme.length; i++) {
    if (currentFillUpScheme[i] === 0) {
      paddedPictures.splice(i, 0, {});
    }
  }

  const MAX_NUMBER_OF_COLUMNS = isTablet ? 3 : 1;

  const formattedArray = [];
  for (let column = 0; column < MAX_NUMBER_OF_COLUMNS; column++) {
    const subArray = [];
    for (let item = 0; item < 3; item++) {
      if (isTablet) {
        subArray.push(paddedPictures[item + column * 3]);
      } else {
        subArray.push(pictures[item + column * 3]);
      }
    }
    formattedArray.push(subArray);
  }

  return (
    <Fragment>
      <div className="flex -mx-2 justify-center">
        {formattedArray.map((array, primaryArrayIndex) => {
          const currentImageStyles = imageStyles[primaryArrayIndex];
          return (
            <div
              key={primaryArrayIndex}
              className="sm:w-1/3 px-2 flex flex-wrap self-center justify-between"
            >
              {array.map((picture, secondaryArrayIndex) => {
                return isEmpty(picture) ? (
                  <div
                    style={{
                      borderRadius: '2px',
                      width: '100%',
                      ...currentImageStyles[secondaryArrayIndex],
                    }}
                  />
                ) : (
                  <div
                    className="overflow-hidden"
                    style={{
                      borderRadius: '2px',
                      width: '100%',
                      ...currentImageStyles[secondaryArrayIndex],
                    }}
                    data-testid="SocialPicturesGrid-thumbnail"
                    key={picture.src}
                  >
                    <SocialPicture src={picture.src} userName={picture.userName} />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </Fragment>
  );
}
